module.exports = __webpack_public_path__ + "img/interface.f10a1200.png";